module.exports = __webpack_public_path__ + "static/media/supplies.47936bd6.svg";